import LoyaltyAvatarPageContainer from "containers/pages/LoyaltyAvatarPageContainer";
import { LoyaltyListRewardsRedesignContainer } from "containers/organisms/LoyaltyListRewardsRedesignContainer";
import { LoyaltyGetRewards } from "components/organisms/LoyaltyGetRewards";
import { LoyaltyMoreRewards } from "components/organisms/LoyaltyMoreRewards";
import { LoyaltyTabs } from "constants/loyalty";
import { LoyaltyTitle } from "../../atoms/LoyaltyTitle";

export const LoyaltyContents = {
  [LoyaltyTabs.REWARDS]: (
    <>
      <LoyaltyListRewardsRedesignContainer />
      <LoyaltyMoreRewards />
    </>
  ),
  [LoyaltyTabs.INFO]: <LoyaltyGetRewards />,
  [LoyaltyTabs.AVATAR]: (
    <>
      <LoyaltyTitle title="loyalty.avatar.title" />
      <LoyaltyAvatarPageContainer />
    </>
  ),
};
